import { SlidersHorizontal } from "lucide-react";
import { useEffect, useMemo, useState } from "react";

const PROVIDER_ICON_SLUGS: Record<string, string> = {
  openai: "openai",
  anthropic: "anthropic",
  google: "google",
  "openai.azure": "azure",
  "amazon.bedrock": "bedrock",
  "anthropic.bedrock": "bedrock",
  together: "together",
  anyscale: "anyscale",
  huggingface: "huggingface",
  cohere: "cohere",
  gemini: "gemini",
  mistral: "mistral",
  fireworks: "fireworks",
  groq: "groq",
  llama: "llama",
  vertexai: "vertexai",
  settings: "settings",
  openclaw: "openclaw",
};

export interface ProviderIconProps {
  provider: string;
  className?: string;
  filter?: string;
}

export const ProviderIcon = ({
  provider,
  className = "h-3.5 w-3.5 shrink-0",
  filter,
}: ProviderIconProps) => {
  const [error, setError] = useState(false);
  const slug = useMemo(() => PROVIDER_ICON_SLUGS[provider || ""] || provider, [provider]);

  useEffect(() => {
    setError(false);
  }, [slug]);

  if (error) {
    return <SlidersHorizontal className={`${className} text-gray-400`} />;
  }

  return (
    <img
      src={`https://unpkg.com/@lobehub/icons-static-svg@latest/icons/${slug}.svg`}
      alt={`${provider} icon`}
      className={`${className} ${filter ?? ""}`}
      onError={() => setError(true)}
    />
  );
};
